/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCreateNoteDraft,
    InternalApiCreateNoteDraftFromJSON,
    InternalApiCreateNoteDraftToJSON,
    InternalApiDraftReferenceType,
    InternalApiDraftReferenceTypeFromJSON,
    InternalApiDraftReferenceTypeToJSON,
    InternalApiNoteDraft,
    InternalApiNoteDraftFromJSON,
    InternalApiNoteDraftToJSON,
    InternalApiUpdateNoteDraft,
    InternalApiUpdateNoteDraftFromJSON,
    InternalApiUpdateNoteDraftToJSON,
} from '../models';

export interface CreateNoteDraftRequest {
    internalApiCreateNoteDraft: InternalApiCreateNoteDraft;
}

export interface DeleteNoteDraftRequest {
    id: number;
}

export interface FindNoteDraftsRequest {
    referenceId: number;
    referenceType: InternalApiDraftReferenceType;
}

export interface UpdateNoteDraftRequest {
    id: number;
    internalApiUpdateNoteDraft: InternalApiUpdateNoteDraft;
}

/**
 * 
 */
export class NoteDraftInternalApi extends runtime.BaseAPI {

    /**
     * Create a new draft note
     */
    async createNoteDraftRaw(requestParameters: CreateNoteDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiNoteDraft>> {
        if (requestParameters.internalApiCreateNoteDraft === null || requestParameters.internalApiCreateNoteDraft === undefined) {
            throw new runtime.RequiredError('internalApiCreateNoteDraft','Required parameter requestParameters.internalApiCreateNoteDraft was null or undefined when calling createNoteDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/note-drafts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCreateNoteDraftToJSON(requestParameters.internalApiCreateNoteDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiNoteDraftFromJSON(jsonValue));
    }

    /**
     * Create a new draft note
     */
    async createNoteDraft(requestParameters: CreateNoteDraftRequest, initOverrides?: RequestInit): Promise<InternalApiNoteDraft> {
        const response = await this.createNoteDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a draft note
     */
    async deleteNoteDraftRaw(requestParameters: DeleteNoteDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteNoteDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/note-drafts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a draft note
     */
    async deleteNoteDraft(requestParameters: DeleteNoteDraftRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteNoteDraftRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches user\'s drafts for a reference
     */
    async findNoteDraftsRaw(requestParameters: FindNoteDraftsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiNoteDraft>>> {
        if (requestParameters.referenceId === null || requestParameters.referenceId === undefined) {
            throw new runtime.RequiredError('referenceId','Required parameter requestParameters.referenceId was null or undefined when calling findNoteDrafts.');
        }

        if (requestParameters.referenceType === null || requestParameters.referenceType === undefined) {
            throw new runtime.RequiredError('referenceType','Required parameter requestParameters.referenceType was null or undefined when calling findNoteDrafts.');
        }

        const queryParameters: any = {};

        if (requestParameters.referenceId !== undefined) {
            queryParameters['referenceId'] = requestParameters.referenceId;
        }

        if (requestParameters.referenceType !== undefined) {
            queryParameters['referenceType'] = requestParameters.referenceType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/note-drafts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiNoteDraftFromJSON));
    }

    /**
     * Fetches user\'s drafts for a reference
     */
    async findNoteDrafts(requestParameters: FindNoteDraftsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiNoteDraft>> {
        const response = await this.findNoteDraftsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing draft note
     */
    async updateNoteDraftRaw(requestParameters: UpdateNoteDraftRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiNoteDraft>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateNoteDraft.');
        }

        if (requestParameters.internalApiUpdateNoteDraft === null || requestParameters.internalApiUpdateNoteDraft === undefined) {
            throw new runtime.RequiredError('internalApiUpdateNoteDraft','Required parameter requestParameters.internalApiUpdateNoteDraft was null or undefined when calling updateNoteDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/note-drafts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateNoteDraftToJSON(requestParameters.internalApiUpdateNoteDraft),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiNoteDraftFromJSON(jsonValue));
    }

    /**
     * Update an existing draft note
     */
    async updateNoteDraft(requestParameters: UpdateNoteDraftRequest, initOverrides?: RequestInit): Promise<InternalApiNoteDraft> {
        const response = await this.updateNoteDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
